import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Patient } from '@pixacare/domain';
import { AuthorizationsService } from 'src/app/services/authorizations.service';
import { CreateContentDirective } from './create-content.directive';

@UntilDestroy()
@Directive({
  selector: '[showIfClientIsGamEnabled]',
  standalone: true,
})
export class ShowIfClientIsGamEnabledDirective extends CreateContentDirective {
  protected authorizationsService = inject(AuthorizationsService);
  protected templateRef: TemplateRef<any>;
  protected container: ViewContainerRef;

  constructor() {
    const templateRef = inject<TemplateRef<any>>(TemplateRef);
    const container = inject(ViewContainerRef);

    super();

    this.templateRef = templateRef;
    this.container = container;
  }

  @Input()
  set showIfClientIsGamEnabled(patient: Patient) {
    this.authorizationsService
      .isCurrentClientGamEnabled$()
      .pipe(untilDestroyed(this))
      .subscribe((isEnabled) => {
        if (patient) {
          this.createContent(isEnabled && patient.isGamLinked);
        } else {
          this.createContent(isEnabled);
        }
      });
  }
}
